/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your signature`)
};

const es_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu firma`)
};

const de_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Signatur`)
};

const nl_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uw handtekening`)
};

const fr_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre signature`)
};

const it_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua firma`)
};

const pt_br2_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua assinatura`)
};

const pt_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua assinatura`)
};

const ja_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの署名`)
};

const zh_sig_preview_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的签名`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_preview_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_preview_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_preview_placeholder", locale)
	if (locale === "en") return en_sig_preview_placeholder(inputs)
	if (locale === "es") return es_sig_preview_placeholder(inputs)
	if (locale === "de") return de_sig_preview_placeholder(inputs)
	if (locale === "nl") return nl_sig_preview_placeholder(inputs)
	if (locale === "fr") return fr_sig_preview_placeholder(inputs)
	if (locale === "it") return it_sig_preview_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_sig_preview_placeholder(inputs)
	if (locale === "pt") return pt_sig_preview_placeholder(inputs)
	if (locale === "ja") return ja_sig_preview_placeholder(inputs)
	return zh_sig_preview_placeholder(inputs)
};